import React from 'react';
import formateText from '../../../utils/Formate';

const SetupTittle = ({text}) => {
    return (
        <h1 className="text-2xl lg:text-3xl font-semibold tracking-tight text-stone-900 mb-5">{formateText(text)}</h1>
    );
};

export default SetupTittle;
